// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alog {
  min-height: 100dvh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #f5f5f5;
}

/* Left */
.alog__left {
  position: relative;
  overflow: hidden;
  min-height: 100dvh;
}
.alog__left-bg {
  position: absolute;
  inset: 0;
}
.alog__bg-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 35%;
}
.alog__bg-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(170deg, rgba(18, 26, 16, 0.7) 0%, rgba(18, 26, 16, 0.35) 40%, rgba(12, 18, 10, 0.85) 95%);
}
.alog__left-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: clamp(2rem, 5vw, 3.5rem);
}
.alog__left-logo {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}
.alog__brand {
  font-weight: 700;
  font-size: 0.92rem;
  letter-spacing: 0.22em;
  color: #fff;
  margin: 0;
  line-height: 1.1;
}
.alog__brand-sub {
  font-size: 0.5rem;
  letter-spacing: 0.18em;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
  margin: 0;
}
.alog__left-hero {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.9rem;
}
.alog__headline {
  font-family: var(--font-serif);
  font-size: clamp(1.8rem, 3.5vw, 3rem);
  font-weight: 600;
  color: #fff;
  margin: 0;
  line-height: 1.2;
}
.alog__headline-rust {
  color: var(--admin-rust-soft);
  display: block;
}
.alog__rule {
  display: block;
  width: 2.5rem;
  height: 3px;
  background: var(--admin-rust);
  border-radius: 2px;
}
.alog__hero-sub {
  font-size: clamp(0.85rem, 1.2vw, 1rem);
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.65;
  margin: 0;
}
.alog__badge {
  display: flex;
}
.alog__badge .wws__badge {
  width: 88px !important;
  height: 88px !important;
}

/* Right */
.alog__right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(2rem, 5vw, 3rem) clamp(1.5rem, 4vw, 2.5rem);
  gap: 1.25rem;
  background: #f5f5f5;
}

.alog__card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 14px;
  padding: clamp(1.75rem, 4vw, 2.5rem);
  width: 100%;
  max-width: 440px;
  position: relative;
  overflow: hidden;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
}
.alog__card-mtn {
  position: absolute;
  top: 0;
  right: 0;
  width: 55%;
  height: 42%;
  overflow: hidden;
  pointer-events: none;
  opacity: 0.15;
}
.alog__card-mtn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center bottom;
  filter: grayscale(1);
}

.alog__card-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: rgba(var(--admin-rust-rgb), 0.08);
  color: var(--admin-rust);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  padding: 0.3rem 0.75rem;
  border-radius: 99px;
  margin-bottom: 1rem;
  position: relative;
}
.alog__shield {
  font-size: 0.85rem;
}

.alog__card-title {
  font-family: var(--font-serif);
  font-size: 1.85rem;
  font-weight: 600;
  color: #111;
  margin: 0 0 0.35rem;
  position: relative;
}
.alog__card-sub {
  font-size: 0.86rem;
  color: #6b7280;
  margin: 0 0 1.75rem;
  line-height: 1.55;
}

.alog__form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.alog__field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.alog__label {
  font-size: 0.84rem;
  font-weight: 600;
  color: #111;
}
.alog__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.alog__forgot {
  font-size: 0.76rem;
  color: var(--admin-rust);
  text-decoration: none;
  font-weight: 600;
}
.alog__forgot:hover {
  color: var(--admin-rust-dk);
}

.alog__input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.alog__input-icon {
  position: absolute;
  left: 0.9rem;
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.28);
  pointer-events: none;
}
.alog__input {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  padding: 0.82rem 0.9rem 0.82rem 2.6rem;
  font-size: 0.9rem;
  color: #111;
  outline: none;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}
.alog__input::placeholder {
  color: rgba(0, 0, 0, 0.28);
}
.alog__input:focus {
  border-color: var(--admin-rust);
  box-shadow: 0 0 0 3px rgba(var(--admin-rust-rgb), 0.1);
}
.alog__pw-toggle {
  position: absolute;
  right: 0.9rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.55);
  padding: 0.2rem;
  min-width: 32px; min-height: 32px;
  display: inline-flex; align-items: center; justify-content: center;
}
.alog__pw-toggle:hover {
  color: #111;
}

.alog__submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  background: var(--admin-rust);
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.95rem;
  font-weight: 700;
  font-size: 0.84rem;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.25rem;
}
.alog__submit:hover:not(:disabled) {
  background: var(--admin-rust-dk);
}
.alog__submit:disabled {
  opacity: 0.6;
  cursor: wait;
}

.alog__back {
  text-align: center;
  margin: 1rem 0 0;
}
.alog__back a {
  font-size: 0.8rem;
  color: #6b7280;
  text-decoration: none;
}
.alog__back a:hover {
  color: #111;
}

.alog__security {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.72rem;
  color: rgba(0, 0, 0, 0.62);
  max-width: 440px;
  text-align: center;
}
.alog__security svg {
  font-size: 1rem;
  flex-shrink: 0;
  color: var(--admin-rust);
}

@media (max-width: 767.98px) {
  .alog {
    grid-template-columns: 1fr;
  }
  .alog__left {
    min-height: clamp(200px, 45vw, 280px);
  }
  .alog__left-hero {
    justify-content: flex-end;
    padding-bottom: 0.5rem;
  }
  .alog__hero-sub {
    display: none;
  }
  .alog__badge {
    display: none;
  }
  .alog__right {
    justify-content: flex-start;
    padding: 1.5rem 1rem;
  }
}
.alog__error {
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.2);
  border-radius: 6px;
  padding: 0.6rem 0.9rem;
  font-size: 0.82rem;
  color: #dc2626;
  margin-bottom: 0.5rem;
}

/* Two-step sign-in */
.alog__input--code { letter-spacing: 0.3em; font-variant-numeric: tabular-nums; font-size: 1.1rem; }
.alog__alt-row { display: flex; justify-content: space-between; gap: 0.75rem; flex-wrap: wrap; margin-top: 0.9rem; }
.alog__link-btn { background: none; border: 0; padding: 0.25rem 0; min-height: 36px; font: inherit; font-size: 0.82rem; font-weight: 600; color: var(--admin-rust); cursor: pointer; text-decoration: underline; text-underline-offset: 3px; }
.alog__link-btn:focus-visible { outline: 2px solid var(--admin-rust); outline-offset: 2px; }
`, "",{"version":3,"sources":["webpack://./src/admin/AdminLogin.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,qHAAqH;AACvH;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;EAC1D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,6CAA6C;EAC7C,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb;;mBAEiB;AACnB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,+BAA+B;EAC/B,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,eAAe,EAAE,gBAAgB;EACjC,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;AACpE;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,qCAAqC;EACvC;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;AACF;AACA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB,qBAAqB,qBAAqB,EAAE,kCAAkC,EAAE,iBAAiB,EAAE;AACnG,iBAAiB,aAAa,EAAE,8BAA8B,EAAE,YAAY,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACnH,kBAAkB,gBAAgB,EAAE,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,aAAa,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,eAAe,EAAE,0BAA0B,EAAE,0BAA0B,EAAE;AAC7O,gCAAgC,oCAAoC,EAAE,mBAAmB,EAAE","sourcesContent":[".alog {\n  min-height: 100dvh;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  background: #f5f5f5;\n}\n\n/* Left */\n.alog__left {\n  position: relative;\n  overflow: hidden;\n  min-height: 100dvh;\n}\n.alog__left-bg {\n  position: absolute;\n  inset: 0;\n}\n.alog__bg-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 35%;\n}\n.alog__bg-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(170deg, rgba(18, 26, 16, 0.7) 0%, rgba(18, 26, 16, 0.35) 40%, rgba(12, 18, 10, 0.85) 95%);\n}\n.alog__left-content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: clamp(2rem, 5vw, 3.5rem);\n}\n.alog__left-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n.alog__brand {\n  font-weight: 700;\n  font-size: 0.92rem;\n  letter-spacing: 0.22em;\n  color: #fff;\n  margin: 0;\n  line-height: 1.1;\n}\n.alog__brand-sub {\n  font-size: 0.5rem;\n  letter-spacing: 0.18em;\n  color: rgba(255, 255, 255, 0.4);\n  text-transform: uppercase;\n  margin: 0;\n}\n.alog__left-hero {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.9rem;\n}\n.alog__headline {\n  font-family: var(--font-serif);\n  font-size: clamp(1.8rem, 3.5vw, 3rem);\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  line-height: 1.2;\n}\n.alog__headline-rust {\n  color: var(--admin-rust-soft);\n  display: block;\n}\n.alog__rule {\n  display: block;\n  width: 2.5rem;\n  height: 3px;\n  background: var(--admin-rust);\n  border-radius: 2px;\n}\n.alog__hero-sub {\n  font-size: clamp(0.85rem, 1.2vw, 1rem);\n  color: rgba(255, 255, 255, 0.65);\n  line-height: 1.65;\n  margin: 0;\n}\n.alog__badge {\n  display: flex;\n}\n.alog__badge .wws__badge {\n  width: 88px !important;\n  height: 88px !important;\n}\n\n/* Right */\n.alog__right {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: clamp(2rem, 5vw, 3rem) clamp(1.5rem, 4vw, 2.5rem);\n  gap: 1.25rem;\n  background: #f5f5f5;\n}\n\n.alog__card {\n  background: #fff;\n  border: 1px solid #e8e8e8;\n  border-radius: 14px;\n  padding: clamp(1.75rem, 4vw, 2.5rem);\n  width: 100%;\n  max-width: 440px;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);\n}\n.alog__card-mtn {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 55%;\n  height: 42%;\n  overflow: hidden;\n  pointer-events: none;\n  opacity: 0.15;\n}\n.alog__card-mtn img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center bottom;\n  filter: grayscale(1);\n}\n\n.alog__card-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  background: rgba(var(--admin-rust-rgb), 0.08);\n  color: var(--admin-rust);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  padding: 0.3rem 0.75rem;\n  border-radius: 99px;\n  margin-bottom: 1rem;\n  position: relative;\n}\n.alog__shield {\n  font-size: 0.85rem;\n}\n\n.alog__card-title {\n  font-family: var(--font-serif);\n  font-size: 1.85rem;\n  font-weight: 600;\n  color: #111;\n  margin: 0 0 0.35rem;\n  position: relative;\n}\n.alog__card-sub {\n  font-size: 0.86rem;\n  color: #6b7280;\n  margin: 0 0 1.75rem;\n  line-height: 1.55;\n}\n\n.alog__form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.alog__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.alog__label {\n  font-size: 0.84rem;\n  font-weight: 600;\n  color: #111;\n}\n.alog__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.alog__forgot {\n  font-size: 0.76rem;\n  color: var(--admin-rust);\n  text-decoration: none;\n  font-weight: 600;\n}\n.alog__forgot:hover {\n  color: var(--admin-rust-dk);\n}\n\n.alog__input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.alog__input-icon {\n  position: absolute;\n  left: 0.9rem;\n  font-size: 0.95rem;\n  color: rgba(0, 0, 0, 0.28);\n  pointer-events: none;\n}\n.alog__input {\n  width: 100%;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #fff;\n  padding: 0.82rem 0.9rem 0.82rem 2.6rem;\n  font-size: 0.9rem;\n  color: #111;\n  outline: none;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n.alog__input::placeholder {\n  color: rgba(0, 0, 0, 0.28);\n}\n.alog__input:focus {\n  border-color: var(--admin-rust);\n  box-shadow: 0 0 0 3px rgba(var(--admin-rust-rgb), 0.1);\n}\n.alog__pw-toggle {\n  position: absolute;\n  right: 0.9rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.95rem;\n  color: rgba(0, 0, 0, 0.55);\n  padding: 0.2rem;\n  min-width: 32px; min-height: 32px;\n  display: inline-flex; align-items: center; justify-content: center;\n}\n.alog__pw-toggle:hover {\n  color: #111;\n}\n\n.alog__submit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  width: 100%;\n  background: var(--admin-rust);\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 0.95rem;\n  font-weight: 700;\n  font-size: 0.84rem;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 0.25rem;\n}\n.alog__submit:hover:not(:disabled) {\n  background: var(--admin-rust-dk);\n}\n.alog__submit:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n.alog__back {\n  text-align: center;\n  margin: 1rem 0 0;\n}\n.alog__back a {\n  font-size: 0.8rem;\n  color: #6b7280;\n  text-decoration: none;\n}\n.alog__back a:hover {\n  color: #111;\n}\n\n.alog__security {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 0.72rem;\n  color: rgba(0, 0, 0, 0.62);\n  max-width: 440px;\n  text-align: center;\n}\n.alog__security svg {\n  font-size: 1rem;\n  flex-shrink: 0;\n  color: var(--admin-rust);\n}\n\n@media (max-width: 767.98px) {\n  .alog {\n    grid-template-columns: 1fr;\n  }\n  .alog__left {\n    min-height: clamp(200px, 45vw, 280px);\n  }\n  .alog__left-hero {\n    justify-content: flex-end;\n    padding-bottom: 0.5rem;\n  }\n  .alog__hero-sub {\n    display: none;\n  }\n  .alog__badge {\n    display: none;\n  }\n  .alog__right {\n    justify-content: flex-start;\n    padding: 1.5rem 1rem;\n  }\n}\n.alog__error {\n  background: rgba(220, 38, 38, 0.08);\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  border-radius: 6px;\n  padding: 0.6rem 0.9rem;\n  font-size: 0.82rem;\n  color: #dc2626;\n  margin-bottom: 0.5rem;\n}\n\n/* Two-step sign-in */\n.alog__input--code { letter-spacing: 0.3em; font-variant-numeric: tabular-nums; font-size: 1.1rem; }\n.alog__alt-row { display: flex; justify-content: space-between; gap: 0.75rem; flex-wrap: wrap; margin-top: 0.9rem; }\n.alog__link-btn { background: none; border: 0; padding: 0.25rem 0; min-height: 36px; font: inherit; font-size: 0.82rem; font-weight: 600; color: var(--admin-rust); cursor: pointer; text-decoration: underline; text-underline-offset: 3px; }\n.alog__link-btn:focus-visible { outline: 2px solid var(--admin-rust); outline-offset: 2px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
